import React, { useState, useEffect, useMemo } from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  CircularProgress,
} from '@chakra-ui/react';
import { getFCDataByDeviceName } from '../api/getData';

const FCDataPage = () => {
  const [deviceValues, setDeviceValues] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const data = await getFCDataByDeviceName('FC');
        const filteredData = data.filter(
          device => device.deviceValues.length > 0
        );
        setDeviceValues(filteredData);
        setIsLoading(false);
        setLoaded(true);
      } catch (error) {
        console.error('Error fetching device values:', error);
        setIsLoading(false);
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 600000);
    return () => clearInterval(intervalId);
  }, []);

  const groupedDeviceValues = useMemo(() => {
    return deviceValues.reduce((groups, device) => {
      const groupName = device.deviceName;
      if (!groups[groupName]) {
        groups[groupName] = [];
      }
      groups[groupName].push(device);
      return groups;
    }, {});
  }, [deviceValues]);

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress isIndeterminate color="green.300" />
      </Box>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        opacity: loaded ? 1 : 0,
        transition: 'opacity 0.5s ease',
      }}
    >
      {Object.keys(groupedDeviceValues).map(deviceName => (
        <div
          key={deviceName}
          style={{
            marginRight: '20px',
            border: '1px solid #ccc',
            padding: '10px',
            borderRadius: '8px',
            height: '90vh',
            overflowY: 'auto',
          }}
        >
          <h2
            style={{
              fontWeight: 'bold',
              marginBottom: '10px',
              fontSize: '16px',
              borderBottom: '1px solid #ccc',
            }}
          >
            Device Name: {deviceName}
          </h2>
          <div>
            <Table
              size="sm"
              variant="striped"
              colorScheme="gray"
              fontSize="ml"
              borderRadius="8px"
            >
              <Thead>
                <Tr>
                  <Th>Name</Th>
                  <Th>Value</Th>
                  <Th>Unit</Th>
                </Tr>
              </Thead>
              <Tbody>
                {groupedDeviceValues[deviceName].map((device, deviceIndex) =>
                  device.deviceValues.map(value => (
                    <Tr
                      key={`${deviceName}-${deviceIndex}-${value.name}-${value.value}`}
                    >
                      <Td>{value.name}</Td>
                      <Td>{value.value}</Td>
                      <Td>{value.unit}</Td>
                    </Tr>
                  ))
                )}
              </Tbody>
            </Table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FCDataPage;
